import { IColumnModel, ColumnModel } from 'table-editor';
import { StarbaseEntity, Serializable } from 'starbase-launcher';

/** Describes a set of file uploads as a 'batch'. Also known as 'Upload Log.' */
export class BatchLog extends StarbaseEntity implements Serializable<BatchLog> {

  public batchName: string;
  public beganUpload: Date;
  public finishedUpload: Date;
  public numberOfFilesSelected: number;
  public numberOfFilesSuccessfullyUploaded: number;
  public imageTypeId: number; // UID of the ImageType entity

  constructor(numberOfFiles: number, imageTypeId: number, batchUploadName: string = '') {
    super();
    this.uid = 0;
    this.batchName = batchUploadName;
    this.numberOfFilesSelected = numberOfFiles;
    this.imageTypeId = imageTypeId;
    this.createdDateTime = new Date();
    this.numberOfFilesSuccessfullyUploaded = 0;
  }
  /**Alias to the Starbase UID */
  get batchNo(): number {
    return this.uid;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static BatchLogColumnData(editable: boolean = false): IColumnModel[] {
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Batch #', 'batchNo', 'BatchNo', false, 'number', true, false, 10, false, null, null, 6),
      new ColumnModel('Name', 'batchName', 'BatchName', editable, 'string', false, false, 150, true, null, null, 9.5),
      new ColumnModel('Upload Began', 'beganUpload', 'beganUpload', false, 'date', false, false, 100, false, null, null, 9.5),
      new ColumnModel('Upload Finished', 'finishedUpload', 'FinishedUpload', false, 'date', false, false, 100, true, null, null, 10.5),
      new ColumnModel('Files Attempted', 'numberOfFilesSelected', 'NumberOfFilesSelected', false, 'number', false, false, 100, true, null, null, 13.5),
      new ColumnModel('Files Successful', 'numberOfFilesSuccessfullyUploaded', 'NumberOfFilesSuccessfullyUploaded', false, 'number', false, false, 100, true, null, null, 14),
      new ColumnModel('Image Type', 'imageTypeId', 'ImageTypeId', false, 'number', false, false, 100, false, null, null, 14),
      new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, false, 100, false, null, null, 17),
      // new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, false, 100, false, null, null, 17)
    ];
  }
  deserialize(input: any) {
    // NOTE: Cannot use the Object.assign pattern here due to the getter.
    this.uid = +input.uid;
    this.batchName = (input.batchName) ? input.batchName : '';
    this.beganUpload = input.beganUpload;
    this.createdByUser = input.createdByUser;
    this.createdDateTime = input.createdDateTime;
    this.finishedUpload = input.finishedUpload;
    this.imageTypeId = +input.imageTypeId;
    this.numberOfFilesSelected = input.numberOfFilesSelected;
    this.numberOfFilesSuccessfullyUploaded = input.numberOfFilesSuccessfullyUploaded;

    return this;
  }

  public toReadable(): string {
    return `${this.batchName} (#${this.batchNo}): ${this.numberOfFilesSuccessfullyUploaded.toString()} files`;
  }
}
